import { Injectable } from "@angular/core";
import { StateService } from "@geolib/geoappbase-client";
import { RawParams, TransitionService } from "@uirouter/angular";


export interface IAppState {
    name: string;
    params: RawParams;
}

/**
 * Remembers the app state the user left, so states outside the app (e.g. the handbook) can offer a way back to it.
 */
@Injectable({ providedIn: "root" })
export class AppStateMemory {

    private appState: IAppState | null = null;

    public constructor(
        private readonly transitionService: TransitionService,
        private readonly stateService: StateService,
    ) {
    }

    public registerAppStateListener(): void {
        this.transitionService.onSuccess({ to: "**" }, () => this.rememberAppState());
    }

    public get lastAppState(): IAppState | null {
        return this.appState;
    }

    private rememberAppState(): void {
        const currentState = this.stateService.getCurrentState();

        if (currentState.name && this.stateService.includes("app")) {
            this.appState = { name: currentState.name, params: { ...this.stateService.getParameters() } };
        }
    }

}
